import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import MarketingSection from 'src/components/MarketingSection';
import useMeasure from 'src/shared/hooks/useMeasure';
import CommonTypeCard from './components/CommonTypeCard';
import styles from './styles.module.scss';

const CARD_WIDTH = 232;
const CARD_MARGIN = 30;
const GROUP_LENTH = 3;

const CommonTypeSection = () => {
    const [bind, { width: viewWidth }] = useMeasure();
    const { t } = useTranslation();

    const items = [
        {
            title: t('private_market_pre-ipo_deals'),
            description: t('private_market_pre-ipo_deals_description'),
            imgSrc: '/static/images/img-pre-ipo-copy-6@3x.png',
            href: 'https://www.altive.com/media/insights/understand-pre-ipo-placement',
            gaLabel: 'Pre-IPO Placement',
        },
        {
            title: t('private_market_private_equity'),
            description: t('private_market_private_equity_description'),
            imgSrc: '/static/images/img-pre-ipo-copy-9@3x.png',
            href: 'https://www.altive.com/media/insights/understand-private-equity-fund',
            gaLabel: 'Private Equity Fund',
        },
        {
            title: t('private_market_private_credit'),
            description: t('private_market_private_credit_description'),
            imgSrc: '/static/images/img-pre-ipo-copy-8@3x.png',
            href: 'https://www.altive.com/media/insights/understand-private-debt',
            gaLabel: 'Private Debt',
        },
        {
            title: t('private_market_private_reits'),
            description: t('private_market_private_reits_description'),
            imgSrc: '/static/images/img-pre-ipo-copy-10@3x.png',
            href: 'https://www.altive.com/media/insights/understand-real-assets',
            gaLabel: 'Real Assets',
        },
        {
            title: t('private_market_hedge_fund'),
            description: t('private_market_hedge_fund_description'),
            imgSrc: '/static/images/img-pre-ipo-copy-7@3x.png',
            href: 'https://www.altive.com/media/insights/understand-hedge-fund',
            gaLabel: 'Hedge Fund',
        },
    ];
    const [groupedItems, setGroupedItems] = useState([]);

    const [type, setType] = useState<'desktop' | 'tablet' | 'mobile'>('desktop');

    useEffect(() => {
        const list = [];
        for (let i = 0; i < Math.ceil(items.length / GROUP_LENTH); i += 1) {
            const group = items.slice(i * GROUP_LENTH, (i + 1) * GROUP_LENTH);
            list.push(group);
        }
        setGroupedItems(list);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (viewWidth !== 0) {
            const allCardListWidth = CARD_WIDTH * items.length + CARD_MARGIN * (items.length - 1);
            const threeCardListWidth = CARD_WIDTH * GROUP_LENTH + CARD_MARGIN * (GROUP_LENTH - 1);
            if (allCardListWidth > viewWidth && threeCardListWidth < viewWidth) {
                setType('tablet');
            } else if (threeCardListWidth > viewWidth) {
                setType('mobile');
            } else {
                setType('desktop');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewWidth]);

    return (
        <MarketingSection containerClassName={styles.container} className={styles.inner}>
            <div className={styles.content} {...bind}>
                <p className={styles.title}>{t('private_market_common_types_title')}</p>
                {type === 'desktop' && (
                    <div className={styles.group}>
                        {items.map((x) => (
                            <CommonTypeCard key={x.title} {...x} />
                        ))}
                    </div>
                )}
                {type === 'tablet' &&
                    groupedItems.map((group, i) => (
                        <div className={`${styles.group} ${styles.multiple}`} key={i}>
                            {group.map((x) => (
                                <CommonTypeCard key={x.title} {...x} />
                            ))}
                        </div>
                    ))}
                {type === 'mobile' && (
                    <div className={`${styles.group} ${styles.vertical}`}>
                        {items.map((x) => (
                            <CommonTypeCard key={x.title} {...x} isMobile />
                        ))}
                    </div>
                )}
            </div>
        </MarketingSection>
    );
};

export default CommonTypeSection;
